import { useMemo } from 'react';
import Box from '@mui/material/Box';
import { Chip } from '@/atoms/Chip';
import { Button } from '@/atoms/Button';
import { DataTable, type MRT_ColumnDef } from '@/organisms/Table';
import { TablePageLayout } from '@/templates/TablePageLayout';

/**
 * ThreatsExample
 * Example threats page listing active attack paths by severity.
 */
interface Threat {
  path: string;
  severity: 'critical' | 'high' | 'medium' | 'low';
  entry: string;
  target: string;
}

const data: Threat[] = [
  { path: 'Internet -> ALB -> EC2 -> RDS', severity: 'critical', entry: 'Public ALB', target: 'prod-db-01' },
  { path: 'IAM user -> AssumeRole -> Admin', severity: 'high', entry: 'Leaked key', target: 'admin-role' },
  { path: 'S3 public -> data exfil', severity: 'medium', entry: 's3-backups', target: 'PII bucket' },
];

export function ThreatsExample() {
  const columns = useMemo<MRT_ColumnDef<Threat>[]>(
    () => [
      {
        accessorKey: 'severity',
        header: 'Severity',
        Cell: ({ cell }) => (
          <Chip purpose="severity" level={cell.getValue<Threat['severity']>()} size="small" />
        ),
      },
      { accessorKey: 'path', header: 'Attack path' },
      { accessorKey: 'entry', header: 'Entry point' },
      { accessorKey: 'target', header: 'Target' },
    ],
    [],
  );
  return (
    <Box sx={{ p: 3 }}>
      <TablePageLayout
        title="Threats"
        description="Active attack paths ranked by exploitability."
        actions={<Button variant="destructive">Simulate</Button>}
      >
        <DataTable columns={columns} data={data} />
      </TablePageLayout>
    </Box>
  );
}
